import {Alert, Button, TextField} from 'bonprix-design-system';
import {AdditionalField} from './AdditionalField.jsx';
import {GroupOfMultipleEntries} from './GroupOfMultipleEntries.jsx';

export function AdditionalFields({formValues, formErrors, cdaEntry, subjectConcerns}) {
    const additionalFields = subjectConcerns.find((subject) => subject.value === formValues.subjectIndex)?.concerns.find((concern) => concern.value === formValues.concernIndex)?.additionalFields;

    if(!additionalFields) {
        return null;
    }

    return additionalFields.map((additionalField, index) => {
        switch(additionalField.type) {
            case 'text':
                return <AdditionalField key={index} formErrors={formErrors} cdaEntry={cdaEntry} additionalField={additionalField} />;
            case 'groupOfMultipleEntries':
                return <GroupOfMultipleEntries key={index} fieldConfig={additionalField} formErrors={formErrors} cdaEntry={cdaEntry} />;
            default:
                return (
                    <div className="form-row" key={index}>
                        <Alert isOpen severity="error" showCloseIcon={false}>
                          Field Type "{additionalField.type}" not supported
                        </Alert>
                    </div>
                    );
        }
    });
}
